module.exports = __webpack_public_path__ + "img/home_four_003.de4bdf43.png";